// extracted by mini-css-extract-plugin
export var breadcrumb = "_15-0";
export var breadcrumbArrow = "_15-1";